import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from 'firebase/storage';

// Tu configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCv3Hms7BXwm4PTJdah1wauvXhp3kh_TWw",
  authDomain: "appcomercialcata.firebaseapp.com",
  projectId: "appcomercialcata",
  storageBucket: "appcomercialcata.appspot.com",
  messagingSenderId: "979857340999",
  appId: "1:979857340999:web:63890716e0b582d93c8f62",
  measurementId: "G-85QKJ1G5Q7"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Obtiene las instancias de autenticación y firestore
const auth = getAuth(app);
const db = getFirestore(app);
const analytics = getAnalytics(app);
const storage = getStorage(app);

// Exporta las instancias necesarias
export { auth, db, analytics, storage };

